<script lang="ts">
	import { page } from '$app/state';
	import BtnIcon from '$lib/buttons/v2/btnIcon.svelte';
	import Instagram from '$lib/icons/instagram.svelte';
	import Link from '$lib/icons/link.svelte';
	import LinkedIn from '$lib/icons/linkedIn.svelte';
	import TikTok from '$lib/icons/tikTok.svelte';
	import log from '$lib/utils/log';
	import { copyToClipboard, shareUrl } from '$lib/utils/share';
	import { editable } from '../editable';
	import type { ISbStoryData } from '@storyblok/js';
	import PageGrid from '../components/pageGrid.svelte';
	import { fade } from 'svelte/transition';

	interface Props {
		content: ISbStoryData['content'] & {
			label: string;
		};
	}

	let { content }: Props = $props();

	let copied = $state(false);

	const shareData: ShareData = {
		url: page.url.toString()
	};

	function share() {
		shareUrl(shareData);
	}
</script>

<div use:editable={content}>
	<PageGrid>
		<div class="col-span-full lg:col-start-4 lg:col-end-10">
			<p class="mb-2 text-[18px]/[140%] text-brown-2">{content.label}</p>
			<div class="flex items-center gap-x-2">
				<BtnIcon
					title="Share to Instagram"
					class="flex items-center justify-center lg:hidden"
					onclick={share}
					theme="transparent/stone/brown/border"
				>
					<Instagram class="h-6 w-6" />
				</BtnIcon>

				<BtnIcon
					title="Share to LinkedIn"
					class="flex items-center justify-center lg:hidden"
					onclick={share}
					theme="transparent/stone/brown/border"
				>
					<LinkedIn class="h-6 w-6" />
				</BtnIcon>

				<BtnIcon
					title="Share to TikTok"
					class="flex items-center justify-center lg:hidden"
					onclick={share}
					theme="transparent/stone/brown/border"
				>
					<TikTok class="h-6 w-6" />
				</BtnIcon>

				<BtnIcon
					title="Copy to clipboard"
					class="flex items-center justify-center"
					onclick={async () => {
						try {
							if (shareData.url) {
								await copyToClipboard(shareData.url);
								copied = true;
								setTimeout(() => (copied = false), 2000);
							} else {
								log.scope('Share module').warn('Could not find URL', { shareData });
							}
						} catch (e) {
							log.exception(e);
						}
					}}
					theme="transparent/stone/brown/border"
				>
					<Link class="h-6 w-6" />
				</BtnIcon>
				{#if copied}
					<p transition:fade class="text-[16px]/[110%] font-semibold text-green-2">copied!</p>
				{/if}
			</div>
		</div>
	</PageGrid>
</div>
